export default __webpack_public_path__ + "static/media/fraud_and_security.86653820.svg";